<template>
  <div class='empty'>
    <img src="https://hzwimspic-1251601690.image.myqcloud.com/47466840-89f9-11ea-9c15-a97bbaf00d97_size_80x60">
    <p>暂无数据</p>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
.empty{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 200px;
  padding-bottom: 100px;

  p{
    padding-top:30px;
  }
}
</style>
